// extracted by mini-css-extract-plugin
export default {"popup_body":"styles_popup_body__vIe1q"};